// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1po13","author":"Table_author__Si2FG","authorImage":"Table_authorImage__9S_lm","unreadRow":"Table_unreadRow__n6geZ"};